/**
 * A class for managing cookies.
 */
export class CookieManager {

  static readCookie(cname: string): string {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }

    return '';
  }

  static createCookie(name: string, value: string, daysValid: number) {
    let expires = '';
    const date = new Date();

    date.setTime(date.getTime() + (daysValid * 24 * 60 * 60 * 1000));
    expires = '; expires=' + date.toUTCString();
    
    document.cookie = `${name}=${value}${expires}; path=/`;  
  }

  static deleteCookie(name: string) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
}
